  <div id="menu-anchor"
    [rdsMenuTriggerFor]="rdsMenu"
    rdsMenuTriggerData
    #triggerIcon="rdsMenuTrigger"
    (click)="triggerIcon.openMenu()"
  ></div>
  <rds-menu
    #rdsMenu="rdsMenu"
    yPosition="above"
    backdrop="transparent"
    overlapTrigger
    size="s"
  >
      @for(item of items; track item){
        <button rds-menu-item (click)="item.callback(item)">{{item.text}}</button>
      }
  </rds-menu>
